import { CircularProgress } from "@mui/material";
import { useEffect, useState } from "react";
import BackButton from "../components/templates/components/backButton";

import '../shared/styles/morePageStyle.css';
import '../shared/styles/otherPageStyle.css';
import './componentsStyle.css';

interface StaticPageProps {
  page: string;
  culture: string;
}

const StaticPage: React.FC<StaticPageProps> = ({
  page,
  culture
}) => {

  const [pageContent, setPageContent] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    setLoading(true);
    const getPage = async () => {
      const response = await fetch(`en/outil-interactif/7344233/${culture}/${page}.html`);
      const data = await response.text();
      setPageContent(data);
      setLoading(false);
    }
    getPage();
  }, [page, culture]);

  return loading ?
    <CircularProgress/> :
    <>
      {
        page === 'more' ?
        (<div className="back-container">
          <BackButton></BackButton>
        </div>) :
        undefined
      }
      <div dangerouslySetInnerHTML={{__html: pageContent}}></div>
    </>
    
  ;
}

export default StaticPage;